import React, { useState } from 'react'
import { injectIntl } from 'react-intl'
import { useDispatch, connect } from 'react-redux'
import { Button, Modal, Form } from 'antd'
import { MaskedInput } from 'antd-mask-input'
import styled from 'styled-components'
import ReservationAction from 'redux/reservation/actions'
import FormItem from '../../../form/FormItem'
import './SignInModal.css'
import getCountries from './countryList.json'

const StylPhone = styled.form`
  width: 100%;
  max-width: 460px;
  display: flex;
  align-items: stretch;

  select {
    width: 60px;
    margin-right: 10px;
    padding-left: 10px;
    border-color: rgb(228 233 240);
    border-radius: 8px;
    height: 50px;
    border-width: 1px;
    appearance: auto;
    font-size: 16px;
  }

  select:focus {
    border-color: #000000;
  }

  select:hover {
    border-color: #000000;
  }
`

const mapStateToProps = ({ reservation }) => ({
  businessCountry:
    reservation?.countryCode || reservation?.businessDetails?.location?.address?.country,
})

const getCountryCallingCode = (country) => {
  return getCountries.find(o => o.code === country)?.phone
}

const getCountryName = (country) => {
  return getCountries.find(o => o.code === country)?.name
}

const SignInModal = ({
  visible,
  theme_color,
  business_id,
  loading,
  businessCountry,
  intl: { formatMessage },
}) => {

  const dispatch = useDispatch()
  const [phone, set] = useState('')
  const [country, setCountry] = useState(businessCountry)
  const [code, setCode] = useState(`+${getCountryCallingCode(businessCountry)}`)
  const [errMsg, setErr] = useState('')

  const onSubmit = () => {
    const val = phone.replaceAll("_", "");
    if (val.length === 14) {
      dispatch({
        type: ReservationAction.SEND_OTP,
        payload: {
          business_id,
          phone_number: val,
          country,
        },
      })
    } else {
      setErr('Invalid mobile number')
    }
  }

  const onCancel = () => {
    dispatch({
      type: ReservationAction.SET_STATE,
      payload: {
        singInPopUp: false,
      },
    })
  }

  const setCountryCode = (valueInfo) => {
    setCountry(valueInfo)
    setCode(`+${getCountryCallingCode(valueInfo)}`)
  }

  const mainCountry = ['US', 'CA', 'GB']

  const getFilterCountry = () => {
    const list = []
    for (let i = 3; i < getCountries.length; i += 1) {
      list.push(getCountries[i])
    }
    return list
  }

  const CountrySelect = ({ value, onChange, ...rest }) => (
    <select {...rest} value={value} onChange={(event) => onChange(event.target.value || undefined)}>
      {mainCountry.map((countryInfo) => (
        <option key={countryInfo} value={countryInfo}>
          {countryInfo}&#160;&#160;&#160;{getCountryName(countryInfo)} +{getCountryCallingCode(countryInfo)}
        </option>
      ))}
      <option disabled>---------------------------------------------</option>
      {getFilterCountry().map((countryInfo) => (
        <option key={countryInfo.code} value={countryInfo.code}>
          {countryInfo.code}&#160;&#160;&#160;{countryInfo.name} +
          {countryInfo.phone}
        </option>
      ))}
    </select>
  )

  return (
    <Modal visible={visible} onCancel={onCancel} footer={null} centered width={460}>
      <Form
        initialValues={{}}
        requiredMark={false}
        layout="vertical"
        autoComplete='off'
        onFinish={onSubmit}
      >
        <div className='sign-in-modal'>
          <div className='sign-in-header'>
            <h3 className="sign-in-title">Sign In</h3>
            <p className="sign-in-sub-text">Enter your mobile number to continue</p>
          </div>
          <FormItem errMsg={errMsg}>
            <StylPhone>
              <CountrySelect value={country} onChange={setCountryCode} />
              <MaskedInput
                mask="(111) 111-1111"
                placeholder="Mobile Number"
                size="large"
                style={{ fontSize: 15, height: 50, width: 340, color: '#757575' }}
                prefix={code}
                onChange={(e) => {
                  const val = e.target.value
                  if (errMsg && val) {
                    setErr('')
                  }
                  set(val)
                }}
              />
            </StylPhone>
          </FormItem>
        </div>
        <div className="text-right">
          <Form.Item>
            <Button size="large" type="danger" style={{ fontSize: 18, height: 50, borderRadius: 5, backgroundColor: theme_color, borderColor: theme_color }} htmlType="submit" loading={loading} block>
              {formatMessage({ id: 'action.Continue' })}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  )
}

export default connect(mapStateToProps)(injectIntl(SignInModal))
